import React from 'react';
import { Button, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import LazyHero from 'react-lazy-hero';


const backgroundImage = process.env.PUBLIC_URL + '/images/hoverSmall.jpg';

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 0, 0, 0),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  background: {
    backgroundImage: backgroundImage,
    backgroundColor: '#ffffff', // Average color of the background image.
    backgroundPosition: 'center',
  },
  h5: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
    },
  },
  more: {
    marginTop: theme.spacing(2),
  },
  subtitle: {
    fontSize: '20px',
    fontWeight: 'lighter',
  }
}));

export default function Header(props) {
  const classes = useStyles();
  return (
    <div className={classes.heroContent}>
      <LazyHero imageSrc={backgroundImage} className={classes.background} minHeight={'220px'} parallaxOffset={"100px"} opacity={0.6} style={{ 'opacity': 1.0, height: '220px', "parallaxOffset": "100px" }}>
        <Typography color="textPrimary" align="center" variant="h3" style={{ fontWeight: "200" }} marked="center">
          {props.title}
        </Typography>

        <Box style={{ paddingTop: '20px' }}>
          <Typography className={classes.subtitle} style={{ paddingBottom: '5px' }}>
            {props.subTitle || "Nothing Stands Still Benchmark"}
          </Typography>
        </Box>
      </LazyHero>
    </div>
  );
}